/**
 * Resolved API origin for raw `fetch` calls (multipart upload, template
 * download) and the typed client base URL.
 *
 * On production the SPA (Cloudflare Pages) and the API (Railway) live on
 * different origins, so `VITE_API_URL` is baked into the bundle as the absolute
 * API URL. In local dev it is unset and falls back to `/api`, which the Vite
 * proxy forwards to the API container.
 *
 * Single source of truth — do NOT re-derive `import.meta.env.VITE_API_URL`
 * inline elsewhere. `||` (not `??`) so an empty-string env also falls back.
 */
export const API_BASE: string = import.meta.env.VITE_API_URL || '/api';
